import { MessagesInterface } from '../../../general/model';

export const Messages = {
  loadFavoritesError: () => ({
    title: 'Server request error',
    message: 'Favorites have not been received. Contact your administrator or support chat.',
  }),
  addFavoriteError: () => ({
    title: 'Server request error',
    message: 'Favorite has not been added. Contact your administrator or support chat.',
  }),
  deleteFavoriteError: () => ({
    title: 'Server request error',
    message: 'Favorite has not been deleted. Contact your administrator or support chat.',
  }),
  renameFavoriteError: () => ({
    title: 'Server request error',
    message: 'Favorite has not been renamed. Contact your administrator or support chat.',
  }),
} as MessagesInterface;

export enum Column {
  remover = 'remover',
  name = 'name',
}

// Где открыто переименование. Одна и та же папка бывает видна сразу и в
// сайдбаре, и в таблице на странице избранного, а поповер привязан к своему
// карандашу — без места он открывался бы в обоих.
export type RenamePlace = 'sidebar' | 'table';

export type FavoriteShape = {
  isLoading: boolean;
  list: Favorite[];
  baseIdsInProgress: (number | null)[]; // TODO: это правда так надо?
  renamingId: number | null;
  renamingPlace: RenamePlace | null;
  renamingText: string;
  renamingIdsInProgress: (number | null)[]; // TODO: это правда так надо?
};

export const initialState: FavoriteShape = {
  isLoading: false,
  list: [],
  baseIdsInProgress: [],
  renamingId: null,
  renamingPlace: null,
  renamingText: '',
  renamingIdsInProgress: [],
};

export const MAX_PANEL_ITEMS = 10;

export interface IFavorite {
  id: number;
  node_id: number;
  name: string;
}

export class Favorite {
  id: number;
  node_id: number;
  name: string;

  constructor(favorite: IFavorite) {
    this.id = favorite.id;
    this.node_id = favorite.node_id;
    this.name = favorite.name;
  }

  clone() {
    return new Favorite(this);
  }
}

export const EMPTY_TABLE_MESSAGE =
  'Favorites will be displayed here when you add them in the file manager';
